import { render } from "./BenchmarkPerformanceChart.vue?vue&type=template&id=1aac44e0&scoped=true"
import script from "./BenchmarkPerformanceChart.vue?vue&type=script&lang=js"
export * from "./BenchmarkPerformanceChart.vue?vue&type=script&lang=js"

import "./BenchmarkPerformanceChart.vue?vue&type=style&index=0&id=1aac44e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aac44e0"]])

export default __exports__